// src/components/GuruPeethLogo.js
import React from "react";
import GuruPeethLogoImg from "../assets/SRI GURUPHIT LOGO.png";
import "./GuruPeethLogo.css";

export default function GuruPeethLogo({ variant = "default" }) {
  return (
    <div className={`gurupeeth-logo-container ${variant}`}>
      <div className="gurupeeth-mark">
        <img src={GuruPeethLogoImg} alt="Shree Gurupeeth Logo" className="gurupeeth-logo-img" />
      </div>
    </div>
  );
}